import {Grid, styled, TextField, Typography} from "@mui/material";
import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import MWCaption from "../../components/MWCaption";

import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import {Box} from "@mui/system";
import {EQDepartment} from "../../models/serverModels/EQDepartment";

const CategoryFormContainer = styled(Grid)(({theme}) => ({
  justifyContent: "center",
  alignItems: "center",
  marginTop: "16px",

  backgroundColor: theme.palette.custom.main,
  "& p": {
    marginTop: "8px",
  },
}));

const CategoryFormContent = styled(Grid)(({theme}) => ({
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  margin: "48px 0",

  padding: "36px",
  border: `1px solid ${theme.palette.background.paper}`,
  borderRadius: "16px",
  boxShadow:
    "rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem",

  "& label": {
    fontWeight: 600,
    paddingRight: "8px",
  },
}));

const DocumentList = styled(Box)(({theme}) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  "& label": {
    flexBasis: "30%",
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));

type SubTitleColorProps = {
  captionColor?: string;
};

const DepartmentForm = ({captionColor}: SubTitleColorProps) => {
  const methods = useFormContext<EQDepartment>();

  const {control} = methods;

  return (
    <React.Fragment>
      <MWCaption title="부서관리" color={captionColor} icon={<ManageAccountsIcon />} />
      <CategoryFormContainer container>
        <CategoryFormContent
          item
          xs={12}
          sm={12}
          md={6}
          xl={4}
          sx={{padding: {xs: "16px 4px", sm: "16px 8px", md: "24px"}}}
        >
          <Controller
            name="name"
            control={control}
            render={({field, fieldState: {error}}) => (
              <DocumentList>
                <label htmlFor="name">부서명 : </label>

                <TextField
                  {...field}
                  id="name"
                  size="small"
                  placeholder="부서명"
                  margin="dense"
                  helperText={error?.message}
                  autoFocus
                  sx={{width: "100%"}}
                />
              </DocumentList>
            )}
          />
        </CategoryFormContent>
      </CategoryFormContainer>
    </React.Fragment>
  );
};

export default DepartmentForm;
